import Ingresar from './Ingresar'
export default Ingresar
